import { Component, OnInit } from '@angular/core';
import { PerfectScrollbarConfigInterface } from 'ngx-perfect-scrollbar';
import { InfoRegraFormula } from 'src/app/models/info-regra-formula';
import { MatDialogRef } from '@angular/material';
import { CarregandoService } from 'src/app/services/carregando.service';
import { NotificacaoService } from 'src/app/services/notificacao.service';
import { UtilitarioService } from 'src/app/services/utilitario.service';
import { GlobalService } from 'src/app/services/global.service';
import { FornecedorEstruturaService } from 'src/app/services/fornecedor-estrutura.service';


@Component({
  selector: 'app-info-regras-estrutura-modal',
  templateUrl: './info-regras-estrutura-modal.component.html',
  styleUrls: ['./info-regras-estrutura-modal.component.scss']
})
export class InfoRegrasEstruturaModalComponent implements OnInit {

  public config: PerfectScrollbarConfigInterface = {};
  infos: InfoRegraFormula;


  constructor(
    public dialogRef: MatDialogRef<InfoRegrasEstruturaModalComponent>,
    private carregandoService: CarregandoService,
    private notificacaoService: NotificacaoService,
    private fornecedorEstruturaService: FornecedorEstruturaService
  ) { }

  ngOnInit(): void {
    this.buscarInfos();
  }

  voltar() {
    this.dialogRef.close();
  }

  buscarInfos() {
    this.carregandoService.mostra('buscarInfos');
    this.fornecedorEstruturaService.consultarInfoRegras().subscribe(
      (retorno) => {
        this.infos = retorno;
        this.carregandoService.esconde('buscarInfos');
      },
      (erro) => {
        this.carregandoService.esconde('buscarInfos');
        this.notificacaoService.erro(erro);
      }
    );
  }

}
